import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { usePermissions } from "../../context/PermissionContext";
import AccessDenied from "../ui/AccessDenied";

const JournalEntryList = () => {
  const { canView, canCreate } = usePermissions();
  const [entries, setEntries] = useState([]);

  if (!canView("journal")) {
    return <AccessDenied moduleName="Journal Entries" action="view" />;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/api/journal/");
        setEntries(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Journal Entries</h2>
      {entries.length === 0 ? (
        <p>No journal entries found.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Date</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Description</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{e.date}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{e.description}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{e.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div style={{ marginTop: "20px" }}>
        {canCreate("journal") && (
          <Link to="/dashboard/transactions/journal/new" style={{ color: "#0077cc" }}>
            Add New Journal Entry
          </Link>
        )}
      </div>
    </div>
  );
};

export default JournalEntryList;
